/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getRestEndpoint } from 'src/app/helpers/api-url';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  constructor(private http: HttpClient) {}

  getClaimDemographics(claimId: string, reportId: string): Observable<any> {
    const headers = new HttpHeaders().set('X_GROUP_ID', reportId);
    return this.http.get<any>(
      `${getRestEndpoint()}/claims/demographics/${claimId}`,
      { headers },
    );
  }
}
